import BasicResultModel from "../../domain/model/basic_result_model";
import MediaRepository from "../../domain/repository/media_repository";
import { toGalleryResultModel } from "../../domain/mapper/get_gallery_image_result_mapper";

export default class MediaRepositoryImpl extends MediaRepository {
    static #instance = null;
    constructor(mediaApiService) {
        if (MediaRepositoryImpl.#instance) {
            return MediaRepositoryImpl.#instance; // Return the same instance if already created
        }
        super(mediaApiService);
        MediaRepositoryImpl.#instance = this; // Store the instance
    }

    async getChatImages({ chatChannelId, skip, limit = 50 }) {
        const result = await this.mediaApiService.getChatImages({ chatChannelId, skip, limit });
        if (result.success) {
            const galleryResult = toGalleryResultModel(result);
            return galleryResult;
        } else {
            return BasicResultModel({ success: false, message: result.message });
        }
    }
}